import { Component, OnInit } from '@angular/core';
import { HttpService } from '../http.service';

@Component({
  selector: 'tumblr-posts',
  templateUrl: './tumblr.component.html',
  styleUrls: ['./tumblr.component.scss']
})
export class TumblrComponent implements OnInit {

    tumblrPost: Object;
    tumblrLink: string;
    tumblrName: string;
    tumblrAvatar: string;
    public errorMsg;
  
    constructor(private _http: HttpService) { }
  
    ngOnInit(): void {
      this._http.tumblrPost().subscribe(
        data => {
          this.tumblrPost = data.response.posts;
          this.tumblrLink = data.response.blog.url;
          this.tumblrName = data.response.blog.title;
          this.tumblrAvatar = data.response.blog.avatar[3].url;
          // console.log(data);
          // console.log(data.response.blog.avatar[3].url);
          // console.log(this.tumblrLink);
          // console.log(this.tumblrName);
        },
        error => this.errorMsg = error
      );
    } 
  }
